var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 1a11 11 0 1 0 11 11 11.013 11.013 0 0 0 -11-11zm0 20a9 9 0 1 1 9-9 9.01 9.01 0 0 1 -9 9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.242 7.757a1 1 0 0 0 -1.414 0l-2.828 2.829-2.828-2.829a1 1 0 1 0 -1.414 1.414l2.828 2.829-2.828 2.829a1 1 0 1 0 1.414 1.414l2.828-2.829 2.828 2.829a1 1 0 1 0 1.414-1.414l-2.828-2.829 2.828-2.829a1 1 0 0 0 0-1.414z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ui.fc171eef8fae711d03497d9c663c0f07.svg";